import React, { useCallback, useContext, useEffect, useState } from "react";
import { useJwt } from "react-jwt";
import { getMessagesCount, reloadToken } from '../services/ApiService';

export const useAuth = () => {

  const [token, setToken] = useState("");
  const { decodedToken, isExpired, reEvaluateToken } = useJwt("");
  const [auth, setAuth] = useState({loaded: false, intentParamToken: false, isAuthenticated: false});
  const [featureAccess, setFeatureAccess] = useState(()=>{});
  const [messagesUrl, setMessagesUrl] = useState();
  const [messagesTarget, setMessagesTarget] = useState();
  const [messagesCount, setMessagesCount] = useState(0);

  useEffect(()=>{
    const tokenStorage = localStorage.getItem("token");
    if(tokenStorage){
      onAuth(tokenStorage);
    }else{
      //setLoaded(true);
    }
    
    // eslint-disable-next-line
  }, [])

  const loadMessages = useCallback(() => {
    getMessagesCount(messagesUrl, auth?.token)
      .then(response => {
        setMessagesCount(parseInt(response.data.mensajes));
      })
  }, [messagesUrl, auth?.token]);

  useEffect(()=>{ 
    console.log(auth?.token)
    if(!messagesUrl || !messagesTarget) return;
    if(!auth?.token) return;
    loadMessages();
    const timer = setInterval(loadMessages, 20000);
    return () => clearInterval(timer);
  }, [messagesUrl, messagesTarget, auth?.token])

  const reLogin = () => {
    const t = localStorage.getItem("token");
    if(t){
      reloadToken("Bearer " + t)
      .then(response => {
        onAuth(response.data.token);
      }).catch(error => {
        
      });
    }
  }

  useEffect(()=>{
    reEvaluateToken(token);
    // eslint-disable-next-line
  }, [token])

  useEffect(()=>{
  }, [auth.loaded])

  useEffect(()=>{
    if(decodedToken && !isExpired){
      setAuth({
        ...auth, 
        ...decodedToken,
        loaded: true,
        token: "Bearer " + token,
        isAuthenticated: true,
      });  
      localStorage.setItem("token", token);
    }else{
      setAuth({
        ...auth,
        loaded: true,
        token: "",
        isAuthenticated: false,
      });  
      localStorage.removeItem("token");
    }

    // eslint-disable-next-line
  }, [decodedToken, isExpired])
  
  const onSignOut = () => {
    setToken("");
  }

  const onAuth = (token, isParamToken) => {
    //console.log({Auth_onAuth: token})
    if(isParamToken) setAuth({...auth, intentParamToken: true});
    setToken(token);
  }

  return { auth, onAuth, onSignOut, setFeatureAccess, reLogin, messagesCount, setMessagesUrl, messagesTarget, setMessagesTarget };
}

export const AuthContext = React.createContext(useAuth); 

export const useAuthContext = () => { 
  return useContext(AuthContext); 
};

export const AuthProvider = ({ children }) => {
  const auth = useAuth();
  
  return (
    <AuthContext.Provider value={auth}>
      {auth.auth.loaded && children}
    </AuthContext.Provider>
  );
};


